import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import axios from 'axios';

import router from '@/router';

import { delay } from 'lodash';

import moment from 'moment-timezone';

import { getOrgId, unsubscribeAllSnapshots } from './helpers';

// import LogRocket from 'logrocket';

const state = {
  user: null,
  customer: null,
  error: null,
  organization: null,
  notifications: [],
  invitation: null,
  isEmailBlocked: false,
  currentUser: null,
  maerskWhitelist: [],
};

const mutations = {
  update_user(state, payload) {
    state.user = payload;
  },
  update_customer(state, payload) {
    state.customer = payload;
  },
  update_error(state, payload) {
    state.error = payload;
  },
  update_organization(state, payload) {
    state.organization = payload;
  },
  update_invitation(state, payload) {
    state.invitation = payload;
  },
  set_notifications(state, payload) {
    state.notifications = payload;
  },
  push_notification(state, payload) {
    state.notifications = [payload];
  },
  update_isEmailBlocked(state, payload) {
    state.isEmailBlocked = payload;
  },
  set_current_user(state, payload) {
    state.currentUser = payload;
  },
  update_verification(state, payload) {
    console.log(state, payload);
  },
  set_maerskWhitelist(state, payload) {
    state.maerskWhitelist = payload;
  },
};

const actions = {
  auth_action: async ({ commit, dispatch }, payload) => {
    const { uid: userId } = payload || { uid: null };
    let inited = false;

    if (userId) {
      try {
        Vue.prototype.$snapshots.$users_snapshot = firebase
          .firestore()
          .collection('users')
          .doc(userId)
          .onSnapshot((snapshot) => {
            if (snapshot.exists) {
              const {
                user_id: userId,
                name,
                company,
                cell,
                mc,
                orgId,
                scac,
                setup_secret: setupSecret,
                email,
                email_notifications: emailNotifications,
                onboarded,
              } = snapshot.data();

              const authUser = {
                user_id: userId,
                name,
                company,
                cell,
                mc,
                orgId,
                scac,
                email,
                setup_secret: setupSecret,
                email_notifications: emailNotifications,
                onboarded,
              };

              const { orgId: userMc } = authUser;

              if (!inited) {
                dispatch('get_organization', userMc);
                commit('update_user', authUser);

                inited = true;
              } else {
                commit('update_user', authUser);
              }
            }
          });

        const cUser = await firebase.auth().currentUser;

        commit('set_current_user', cUser);
      } catch (error) {
        commit('update_error', error);
      }
    }
  },
  customer_action: async ({ commit, dispatch }, payload) => {
    const { owner_uid: ownerUid } = payload || { owner_uid: null };

    Vue.prototype.$snapshots.$stripe_customer_snapshot = firebase
      .firestore()
      .collection('stripe_customers')
      .doc(ownerUid)
      .onSnapshot((snapshot) => {
        if (snapshot.data()) {
          /**
           * Update all payment methods for logged in customer
           */
          Vue.prototype.$snapshots.$payment_methods_snapshot = firebase
            .firestore()
            .collection('stripe_customers')
            .doc(ownerUid)
            .collection('payment_methods')
            .onSnapshot((snapshot) => {
              const { empty: isEmpty, docs: paymentMethods } = snapshot;

              if (isEmpty) {
                dispatch('stripe/update_payment_methods', [], {
                  root: true,
                });
              } else {
                const allMethods = paymentMethods
                  .map((method) => method.data())
                  .filter(
                    ({ card, bank_account: bankAccount }) => card || bankAccount
                  );

                dispatch('stripe/update_payment_methods', allMethods, {
                  root: true,
                });
              }
              dispatch('stripe/update_payment_methods_status', true, {
                root: true,
              });
            });

          /**
           * Update all payout methods for logged in customer
           */
          Vue.prototype.$snapshots.$payout_methods_snapshot = firebase
            .firestore()
            .collection('stripe_customers')
            .doc(ownerUid)
            .collection('payout_methods')
            .onSnapshot((snapshot) => {
              const { empty: isEmpty, docs: payoutMethods } = snapshot;

              if (isEmpty) {
                dispatch('stripe/update_payout_methods', [], {
                  root: true,
                });
              } else {
                const allMethods = payoutMethods
                  .map((method) => method.data())
                  .filter(
                    ({ card, bank_account: bankAccount }) => card || bankAccount
                  );

                dispatch('stripe/update_payout_methods', allMethods, {
                  root: true,
                });
              }
            });

          /**
           * Get all payments for the logged in customer
           */
          Vue.prototype.$snapshots.$payments_snapshot = firebase
            .firestore()
            .collection('stripe_customers')
            .doc(ownerUid)
            .collection('payments')
            .onSnapshot(({ docs: payments }) => {
              const allPayments = payments.map((payment) => payment.data());

              dispatch('stripe/update_payments', allPayments, { root: true });
            });

          /**
           * Get all payouts for the logged in customer
           */
          Vue.prototype.$snapshots.$payouts_snapshot = firebase
            .firestore()
            .collection('stripe_customers')
            .doc(ownerUid)
            .collection('payouts')
            .onSnapshot(({ docs: payouts }) => {
              const allPayouts = payouts.map((payout) => payout.data());

              dispatch('stripe/update_payouts', allPayouts, { root: true });
            });

          /**
           * Get all subscriptions for the logged in customer
           */
          Vue.prototype.$snapshots.$payouts_snapshot = firebase
            .firestore()
            .collection('stripe_customers')
            .doc(ownerUid)
            .collection('subscriptions')
            .onSnapshot(({ docs: subscriptions }) => {
              const allSubscriptions = subscriptions.map((doc) => doc.data());

              dispatch('stripe/update_subscriptions', allSubscriptions, {
                root: true,
              });
            });

          commit('update_customer', snapshot.data());
        } else {
          console.warn(
            `No Stripe customer found in Firestore for user: ${ownerUid}`
          );
        }
      });
  },
  register_action: async ({ commit, dispatch }, payload) => {
    const user = firebase.auth().currentUser;

    if (user) {
      await user.reload();

      if (!user.emailVerified) {
        await dispatch('update_verification', {
          ...payload,
          email: payload.email.toLowerCase(),
        });

        router
          .push({ path: '/verify', query: { email: payload.email } })
          .catch(() => {});

        return;
      } else {
        const orgId = await getOrgId(payload.email, payload.scac);
        const existingOrganizationRef = await firebase
          .firestore()
          .collection('organizations')
          .doc(orgId)
          .get();

        if (existingOrganizationRef.exists) {
          router.push({ path: '/register/complete' }).catch(() => {});

          return;
        }
      }
    }

    try {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password);

      await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password);

      await dispatch('update_verification', {
        ...payload,
        email: payload.email.toLowerCase(),
      });

      router
        .push({ path: '/verify', query: { email: payload.email } })
        .catch(() => {});
    } catch (err) {
      commit('update_error', err);
    }
  },
  register_complete_action: async ({ commit, dispatch }, payload) => {
    const {
      name,
      company,
      cell,
      mc,
      scac,
      email,
      org_type: orgType,
      reserveContainer = null,
      agencyOrgId = null,
      operatingRegions = null,
      newAgent = null,
      accountType = null,
    } = payload;
    let user = null;
    user = firebase.auth().currentUser;

    if (!user) {
      try {
        user = (
          await firebase
            .auth()
            .signInWithEmailAndPassword(payload.email, payload.password)
        ).user;
      } catch (error) {
        commit('update_error', error);
      }
    }

    try {
      await user.reload();
    } catch (error) {
      commit('update_error', error);
    }

    const { uid: userId } = user;

    const orgId = await getOrgId(email, scac, newAgent);

    try {
      const newUser = {
        user_id: userId,
        name,
        company,
        cell,
        orgId,
        mc,
        scac,
        email,
        email_notifications: true,
        onboarded: orgType === 'exporter',
      };

      await firebase.firestore().collection('users').doc(userId).set(newUser);

      commit('update_user', newUser);
    } catch (err) {
      commit('update_error', err);
    }
    try {
      // now we have to create new organization or connect to existing via orgId
      const org = await firebase
        .firestore()
        .collection('organizations')
        .doc(orgId)
        .get();
      if (!org.exists) {
        delay(async () => {
          const orgData = {
            address: null,
            email,
            company,
            cell,
            location: {
              address: null,
              timezone: moment.tz.guess(),
            },
            mc,
            orgId,
            scac,
            owner_uid: userId,
            empty_locations: [],
            locations: [],
            org_type: orgType,
          };
          if (operatingRegions) {
            orgData.operatingRegions = operatingRegions;
          }
          if (agencyOrgId) {
            orgData.agency_orgid = agencyOrgId;
          }
          if (accountType) {
            orgData.accountType = accountType;
          }
          await firebase
            .firestore()
            .collection('organizations')
            .doc(orgId)
            .set(orgData);

          dispatch('workspace/set_workspace', orgId, { root: true });
          dispatch('get_organization', orgId);

          const org = await (
            await firebase
              .firestore()
              .collection('organizations')
              .doc(orgId)
              .get()
          ).data();

          if (process.env.NODE_ENV === 'production') {
            // post to slack
            await axios.post(
              `${process.env.VUE_APP_DOMAIN}/api/v1/new_carrier_signup`,
              {
                name,
                company,
                email,
                cell,
                scac,
                operatingRegions: operatingRegions?.join(', '),
                orgId,
              }
            );
          }

          if (org) {
            Vue.prototype.$snapshots.$stripe_customers_snapshot = firebase
              .firestore()
              .collection('stripe_customers')
              .doc(org.owner_uid)
              .onSnapshot((snapshot) => {
                commit('update_customer', snapshot.data());
                if (snapshot.data()) {
                  /**
                   * Update all payment methods for logged in customer
                   */
                  Vue.prototype.$snapshots.$payment_methods_snapshot = firebase
                    .firestore()
                    .collection('stripe_customers')
                    .doc(org.owner_uid)
                    .collection('payment_methods')
                    .onSnapshot(async (snapshot) => {
                      const { empty: isEmpty, docs: payments } = snapshot;

                      if (isEmpty) {
                        dispatch('stripe/update_payment_methods', [], {
                          root: true,
                        });
                      } else {
                        const allMethods = payments
                          .map((payment) => payment.data())
                          .filter(({ card }) => card);

                        dispatch('stripe/update_payment_methods', allMethods, {
                          root: true,
                        });
                      }
                    });
                  /**
                   * Update all subscriptions for logged in customer
                   */
                  firebase
                    .firestore()
                    .collection('stripe_customers')
                    .doc(org.owner_uid)
                    .collection('subscriptions')
                    .onSnapshot(async (snapshot) => {
                      const { empty: isEmpty, docs: subscriptions } = snapshot;

                      if (isEmpty) {
                        dispatch('stripe/update_subscriptions', [], {
                          root: true,
                        });
                      } else {
                        const allSubscriptions = subscriptions.map((doc) =>
                          doc.data()
                        );
                        dispatch(
                          'stripe/update_subscriptions',
                          allSubscriptions,
                          {
                            root: true,
                          }
                        );
                      }
                    });
                } else {
                  console.warn(
                    `No Stripe customer found in Firestore for user: ${userId}`
                  );
                }
              });
          }
          dispatch('check_and_create_reservations', reserveContainer);
          router.push({ path: '/register/workspace', query: { new: true } });
        }, 2500);
      } else if (org.exists) {
        if (process.env.NODE_ENV === 'production') {
          // post to slack
          await axios.post(
            `${process.env.VUE_APP_DOMAIN}/api/v1/new_user_signup`,
            {
              name,
              company,
              email,
              cell,
              scac,
              operatingRegions: operatingRegions?.join(', '),
              orgId,
            }
          );
        }
        dispatch('check_and_create_reservations', reserveContainer);
        router.push({
          path: '/register/workspace',
          query: { existing: true },
        });
      }
    } catch (err) {
      commit('update_error', err);
    }

    try {
      const newUser = await firebase
        .firestore()
        .collection('users')
        .doc(userId)
        .get();
      const {
        email: nEmail,
        name: nName,
        company: nCompany,
        cell: nCell,
        mc,
        orgId,
        scac: nScac,
        org_type: orgType,
      } = newUser.data();

      if (newUser.exists) {
        const { owner_uid: ownerUid } = (
          await firebase
            .firestore()
            .collection('organizations')
            .doc(orgId)
            .get()
        ).data();
        const { setup_secret: setupSecret } = (
          await firebase
            .firestore()
            .collection('stripe_customers')
            .doc(ownerUid)
            .get()
        ).data();

        await firebase.firestore().collection('users').doc(userId).update({
          setup_secret: setupSecret,
        });

        // update user again
        commit('update_user', {
          email: nEmail,
          name: nName,
          company: nCompany,
          cell: nCell,
          mc,
          orgId,
          scac: nScac,
          org_type: orgType,
          onboarded: orgType === 'exporter',
          user_id: userId,
        });
        const cUser = await firebase.auth().currentUser;

        commit('set_current_user', cUser);
      } else {
        commit('update_error', 'User does not exist');
      }
    } catch (err) {
      commit('update_error', err);
    }
  },
  login_action: async ({ commit, dispatch }, payload) => {
    const { email, password } = payload;
    let uid;
    let emailVerified;
    try {
      ({
        user: { uid, emailVerified },
      } = await firebase.auth().signInWithEmailAndPassword(email, password));

      try {
        const user = await (
          await firebase.firestore().collection('users').doc(uid).get()
        ).data();

        if (!user) {
          const verificationData = await dispatch(
            'get_verification',
            payload.email
          );
          if (verificationData?.agency_verification) {
            localStorage.setItem('agency_verification', 'pending');
            router
              .push({
                path: '/agent-verify',
                query: { scac: verificationData.scac },
              })
              .catch(() => {});
          } else {
            if (!emailVerified) {
              router
                .push({ path: '/verify', query: { email: payload.email } })
                .catch(() => {});
            } else {
              router
                .push({
                  path: '/register/workspace',
                  query: { existingAgency: true, scac: verificationData.scac },
                })
                .catch(() => {});
            }
          }

          return;
        }

        const { orgId } = user;

        const data = JSON.parse(
          sessionStorage.getItem('selectedReservationData')
        );
        await dispatch('get_organization', orgId);
        if (data) {
          if (data.status === 'available') {
            dispatch('reservations/create_reservation', [data], {
              root: true,
            });
            sessionStorage.removeItem('selectedReservationData');
            router.push('/status').catch(() => {});
          } else {
            window.location.href = data.redirectUrl;
          }
        } else {
          router.push('/dashboard').catch(() => {});
        }
        dispatch('get_organization', orgId);
        const cUser = await firebase.auth().currentUser;

        commit('set_current_user', cUser);
        commit('update_user', user);
      } catch (error) {
        commit('update_error', error);
      }
    } catch (error) {
      commit('update_error', error);
    }
  },
  change_password: async ({ commit }, payload) => {
    const { email, password, new_password: newPassword } = payload;

    const user = firebase.auth().currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(
      email,
      password
    );

    try {
      await user.reauthenticateWithCredential(credential);

      try {
        await user.updatePassword(newPassword);

        await user.reload();
      } catch (error) {
        commit('update_error', error);
      }
    } catch (error) {
      commit('update_error', error);
    }
  },
  logout_action: async ({ commit }) => {
    try {
      await unsubscribeAllSnapshots();

      await firebase.auth().signOut();

      commit('update_user', null);
      commit('update_organization', null);
      commit('stripe/reset', null, { root: true });
    } catch (error) {
      commit('update_error', error);
    }
  },
  revoke: async ({ state, commit, dispatch }, uid) => {
    try {
      await firebase
        .firestore()
        .collection('users')
        .doc(uid)
        .update({ orgId: '' });

      dispatch('get_organization', state.user.orgId);
    } catch (error) {
      commit('update_error', error);
    }
  },
  get_organization: async ({ commit, dispatch, rootGetters }, payload) => {
    let orgId;

    if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].orgId !== 'undefined'
    ) {
      orgId = rootGetters['auth/get_user'].orgId;
    } else {
      orgId = payload;
    }

    const organization = {};
    try {
      Vue.prototype.$snapshots.$organization_data_snapshot = await firebase
        .firestore()
        .collection('organizations')
        .doc(orgId)
        .onSnapshot((snapshot) => {
          const organizationData = snapshot.data();
          organization.owner_uid = organizationData?.owner_uid;
          organization.api_key = organizationData?.api_key;
          organization.integrations = organizationData?.integrations;
          organization.org_type = organizationData?.org_type;
          organization.scac = organizationData?.scac;
          organization.scac_codes = organizationData?.scac_codes;
          organization.company = organizationData?.company;
          organization.account = organizationData?.account;
          organization.vendor_details = organizationData?.vendorDetails;
          organization.additional_emails = organizationData?.additional_emails;
          organization.isTrustedSeller = organizationData?.isTrustedSeller;
          organization.agency_scacs = organizationData?.agency_scacs;
          organization.pending_agent_verifications =
            organizationData?.pending_agent_verifications;
          organization.agency_verfication =
            organizationData?.agency_verfication;
          organization.agency_orgid = organizationData?.agency_orgid;
          organization.insuranceCoverage = organizationData?.insuranceCoverage;
          organization.numberOfTrucks = organizationData?.numberOfTrucks;
          organization.weightAuthorization =
            organizationData?.weightAuthorization;
          organization.operatingRegions = organizationData?.operatingRegions;
          organization.isTrustedSeller = organizationData?.isTrustedSeller;
          organization.mcNumber = organizationData?.mcNumber;
          organization.accountType = organizationData?.accountType;
          commit('update_organization', organization);
        });

      try {
        // get all users of organization
        const { docs: userCollection } = await firebase
          .firestore()
          .collection('users')
          .where('orgId', '==', orgId)
          .get();
        const preparedUserCollection = userCollection.map((userDoc) => ({
          id: userDoc.id,
          ...userDoc.data(),
        }));

        organization.users = preparedUserCollection.reduce(
          (
            organizationUsers,
            {
              id,
              orgId,
              scac,
              user_id: userId,
              name,
              email,
              email_notifications: emailNotifications,
            }
          ) => {
            organizationUsers[id] = {
              orgId,
              scac,
              user_id: userId,
              name,
              email,
              email_notifications: emailNotifications,
            };

            return organizationUsers;
          },
          {}
        );

        organization.owner_email =
          organization.users[organization.owner_uid].email;

        dispatch('customer_action', organization);
        dispatch('config/load_config', orgId, { root: true });
        dispatch('containers/get_organization_containers', orgId, {
          root: true,
        });
        dispatch('containers/get_network_containers', orgId, { root: true });
        dispatch('reservations/get_reservations', orgId, { root: true });
        dispatch('reservations/get_organization_reservations', orgId, {
          root: true,
        });
        dispatch('reservations/get_organization_agreements', null, {
          root: true,
        });
        dispatch('integrations/get_integrations', orgId, { root: true });
        dispatch('integrations/get_available_integrations', orgId, {
          root: true,
        });
        dispatch('lines/get_lines', orgId, { root: true });
        dispatch('containers/get_sizes', orgId, { root: true });
        dispatch('turns/get_all_turns', orgId, { root: true });
        dispatch('turns/get_turns_snapshots', orgId, { root: true });
        dispatch('turns/set_secondary_carrier_snapshots', orgId, {
          root: true,
        });
        dispatch('turns/get_all_locations_data', orgId, { root: true });
        dispatch('workspace/set_workspace', orgId, { root: true });
        dispatch('locations/activeLoadData', orgId, { root: true });
        dispatch('mentions/activeLoadData', orgId, { root: true });
        dispatch('notifications/activeLoadData', orgId, { root: true });
        dispatch('avatar/get_avatar', orgId, { root: true });
        dispatch('containers/get_containers_added_to_network', orgId, {
          root: true,
        });
        dispatch('stripe/get_product_plans', '', { root: true });
        dispatch('bookings/get_export_bookings', orgId, { root: true });
        dispatch('bookings/get_marketplace_bookings', orgId, { root: true });
        // dispatch('get_st_whitelist_organizations', '');
        dispatch('stripe/get_transaction_invoices', '', { root: true });
        dispatch('stripe/get_subscription_invoices', '', { root: true });
        // dispatch('get_maersk_whitelist_org_scac', '');
        // dispatch('settings/get_payment_settings_data', '', { root: true });
        dispatch('settings/get_marketplace_settings_data', '', { root: true });
        dispatch('settings/get_requestload_settings_data', '', { root: true });
        dispatch('bookings/get_trucker_allocation_data', '', { root: true });
        dispatch('chats/getChats', '', { root: true });
      } catch (error) {
        commit('update_error', error);
      }
    } catch (error) {
      commit('update_error', error);
    }
  },
  set_notifications: async ({ commit }, payload) => {
    commit('set_notifications', payload);
  },
  new_notification: async ({ commit }, payload) => {
    commit('push_notification', payload);
  },
  update_organization_user_preferences: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    try {
      await firebase
        .firestore()
        .collection('organizations')
        .doc(rootGetters['auth/get_user'].orgId)
        .update({ ...payload });

      // dispatch('get_organization');

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Updated organization preferences!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  update_user_email_preferences: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    try {
      await firebase
        .firestore()
        .collection('users')
        .doc(rootGetters['auth/get_user'].user_id)
        .update({ email_notifications: payload });

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Updated user email preferences!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  update_verification: async ({ commit }, payload) => {
    try {
      const data = sessionStorage.getItem('selectedReservationData');
      if (data) {
        payload.reserveContainer = [JSON.parse(data).container];
      }
      await firebase
        .firestore()
        .collection('pending_verifications')
        .add(payload);

      // const verificationRef = await verification.get();
      sessionStorage.removeItem('selectedReservationData');
      // commit('update_verification', verificationRef.data());
    } catch (error) {
      commit('update_error', error);
    }
  },
  update_action_code: async ({ commit }, payload) => {
    try {
      const verification = await firebase
        .firestore()
        .collection('pending_verifications')
        .doc(payload);

      const verificationRef = await verification.get();

      commit('update_verification', verificationRef.data());
    } catch (error) {
      commit('update_error', error);
    }
  },
  send_email_verification: async ({ commit, dispatch }) => {
    const userEmail = firebase.auth().currentUser.email;

    // Adding listener to the collection to get the email status update
    let query = firebase.firestore().collection('email_event');
    query = query.where('email', '==', userEmail);
    query.onSnapshot(({ docs }) => {
      const emailData = docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      const latestTime = Math.max(...emailData.map((item) => item.timestamp));
      const data =
        emailData[
          emailData.findIndex(
            (val) => val.timestamp?.toString() === latestTime?.toString()
          )
        ];
      if (
        data?.event?.toLowerCase() === 'bounce' ||
        data?.type?.toLowerCase() === 'blocked'
      ) {
        commit('update_isEmailBlocked', true);
      } else {
        commit('update_isEmailBlocked', false);
      }
    });
    try {
      // await firebase.auth().currentUser.sendEmailVerification({
      //   url: `${process.env.VUE_APP_CANONICAL_URL}/register/complete`,
      // });

      const { data } = await axios.post(
        `${process.env.VUE_APP_CANONICAL_URL}/api/v1/accounts/email_verification`,
        { userEmail }
      );
      if (data.status === 'success') {
        dispatch(
          'auth/new_notification',
          {
            type: 'notification',
            message: 'Verification email sent!',
          },
          { root: true }
        );
      }
    } catch (error) {
      commit('update_error', error);
    }
  },
  get_verification: async ({ commit }, payload) => {
    const pendingVerificationRef = await firebase
      .firestore()
      .collection('pending_verifications')
      .where('email', '==', payload?.toLowerCase())
      .get();

    const verification = pendingVerificationRef.docs[0];

    if (verification?.exists) {
      return verification.data();
    } else {
      return null;
    }
  },
  delete_invitations_and_verifications: async ({ commit }) => {
    const currentUser = firebase.auth().currentUser;

    const pendingVerificationRef = await firebase
      .firestore()
      .collection('pending_verifications')
      .where('email', '==', currentUser.email?.toLowerCase())
      .get();

    const pendingInvitationRef = await firebase
      .firestore()
      .collection('invitations')
      .where('email', '==', currentUser.email?.toLowerCase())
      .get();

    await Promise.all([
      ...pendingVerificationRef.docs.map(async (doc) => await doc.ref.delete()),
      ...pendingInvitationRef.docs.map(async (doc) => await doc.ref.delete()),
    ]);
  },

  // Creating user account after email and scac verification
  email_verification_action: async ({ commit, dispatch }, payload) => {
    const { email, scac } = payload;

    const pendingVerificationRef = await firebase
      .firestore()
      .collection('pending_verifications')
      .where('email', '==', email)
      .where('scac', '==', scac)
      .get();

    const verification = pendingVerificationRef.docs[0];

    if (verification?.exists) {
      const { scac } = verification.data();

      const organizationRef = await firebase
        .firestore()
        .collection('organizations')
        .where('scac', '==', scac)
        .get();

      const { orgId } =
        !organizationRef.empty && organizationRef.docs[0].data();
      return orgId;
    } else {
      return 'error';
    }
  },

  check_and_create_reservations: async (
    { commit, dispatch },
    reserveContainer
  ) => {
    // *********** reserve containers
    if (reserveContainer !== null || reserveContainer !== undefined) {
      try {
        reserveContainer.map(async (val) => {
          await firebase
            .firestore()
            .collection('pending_reservations')
            .doc(val)
            .get()
            .then((doc) => {
              if (doc.data().status === 'available') {
                dispatch('reservations/create_reservation', [doc.data()], {
                  root: true,
                });
              }
            });
        });
      } catch (err) {
        commit('update_error', err);
      }
    }
    // *********** reserve containers
  },

  // Updating additional email data in user collection
  update_user_additional_email_preferences: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    try {
      const value = payload.event
        ? firebase.firestore.FieldValue.arrayUnion(payload.email)
        : firebase.firestore.FieldValue.arrayRemove(payload.email);

      await firebase
        .firestore()
        .collection('organizations')
        .doc(rootGetters['auth/get_user'].orgId)
        .update({
          additional_emails: value,
        });

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Updated user email preferences!',
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  get_maersk_whitelist_org_scac: async ({ commit, rootGetters, dispatch }) => {
    try {
      Vue.prototype.$snapshots.$maersk_whitelist_snapshot = await firebase
        .firestore()
        .collection('maersk_whitelist')
        .onSnapshot(({ docs }) => {
          const orgData = docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          commit('set_maerskWhitelist', orgData);
        });
    } catch ({ message }) {
      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          error: true,
          message,
        },
        { root: true }
      );
    }
  },
  create_existing_agent_workspace: async ({ commit, rootGetters }, payload) => {
    const { name, company, cell, mc, scac, email, orgId } = payload;

    let user = null;
    user = firebase.auth().currentUser;
    if (!user) {
      try {
        user = (
          await firebase
            .auth()
            .signInWithEmailAndPassword(payload.email, payload.password)
        ).user;
      } catch (error) {
        commit('update_error', error);
      }
    }

    try {
      await user.reload();
    } catch (error) {
      commit('update_error', error);
    }

    const { uid: userId } = user;

    try {
      const newUser = {
        user_id: userId,
        name,
        company,
        cell,
        orgId,
        mc,
        scac,
        email,
        email_notifications: true,
        onboarded: false,
      };

      await firebase.firestore().collection('users').doc(userId).set(newUser);

      commit('update_user', newUser);
      this.$router.push('/dashboard').catch(() => {});
    } catch (err) {
      commit('update_error', err);
    }
  },
  update_user_Doc: async ({ commit, dispatch, rootGetters }, payload) => {
    try {
      await firebase
        .firestore()
        .collection('users')
        .doc(rootGetters['auth/get_user'].user_id)
        .update(payload);
    } catch (err) {
      commit('update_error', err);
    }
  },
};

const getters = {
  get_user(state) {
    return state?.user;
  },
  get_customer(state) {
    return state.customer;
  },
  get_error(state) {
    return state.error;
  },
  get_access_token(state) {
    return state.user ? state.user.stsTokenManager.accessToken : null;
  },
  get_org(state) {
    return state.organization;
  },
  get_owner_email(state) {
    if (state.organization) {
      return state.organization?.owner_email;
    } else {
      return null;
    }
  },
  get_notifications(state) {
    return state.notifications;
  },
  get_email_blocked_status(state) {
    return state.isEmailBlocked;
  },
  get_current_user(state) {
    return state.currentUser;
  },
  get_maersk_whitelist_scac(state) {
    return state.maerskWhitelist;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
